import cx from 'classnames';
import React from 'react';
import styles from './order-summary-display.module.css';

interface OrderSummaryDisplayProps {
  children: React.ReactNode[] | React.ReactNode;
  variant?: 'sidebar';
  isInNoDealerFeesExperiment?: boolean;
}

const OrderSummaryDisplay = ({
  children,
  variant,
  isInNoDealerFeesExperiment,
  ...restProps
}: OrderSummaryDisplayProps) => {
  return (
    <div
      className={cx(
        styles.container,
        variant === 'sidebar' && styles.sidebarContainer,
        isInNoDealerFeesExperiment && styles.noDealerFeesExperiment
      )}
      {...restProps}
    >
      {children}
    </div>
  );
};

export default OrderSummaryDisplay;
